var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#198a00",
    fillRule: "evenodd",
    d: "M-6 0h60v40H-6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    d: "M47 14.4h7V40h-7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M40 14.4h7V40h-7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    d: "M32.7 14.4H40V40h-7.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m49.3 5.1 2.9-1.3c.1.1-1 1.5-3.4 2 2.1-.4 3.9-2 4.3-2 0 0 0 1.6-4.7 2.9 3.3-.9 5.2-2.5 5.2-2.3 0 0-.4 1.2-3.3 2.2.8-.2 3-1.5 3-1.3s-2.1 3-6 2c3.1.8 5.1-1.2 5.4-1.1 0 0-.5 1.7-4.5 1.8 1.9-.2 1.3 0 1.3 0s-1 .9-2.4.3l1.2.4c-.1.1-1 .3-1.8-.2l1.3.5q-.2.2-.9 0L43 6.8 49 5zm-7.1 6q-.7.2-.6.4v.3l.1-.2.7-.3q-.3.6-.1.5l.2.4V12q.1.1.3-.5.1.6.2.5l.3.2q-.2-.1-.1-.3s.3-.2 0-.6l.3-.3-.3-.2v-.7l-.1-.7-.4 1.1c0-.1 0 .5-.5.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M44.8 9.4s.4.4.8.4c.1-.1-.3-.4-.3-.4.1.1.8.7 1.2.5.1-.3-.3-.2-.8-.9.3.3 1.2.8 1.6.6.2-.2-.9-.8-1.3-1.2l-.9-.5-1.3 1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M43.4 5.8s.4-.2 2.1 0l1.5-.5c.5-.1 2.1-.5 2.5-.8.4 0 0 .6-.4.7a7 7 0 0 1-2.4.6c.6 0 .2.6-.8.3.5.3.3.3.3.3l-1.1-.1c.6.2.3.3.3.3h-.8q.4 0 .2.1H44c-.3-.1-.7-.8-.7-.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m44 9.6.1 1.2c0 .1-.9 0-.8.5q0 .4.2.5v-.3l.4-.2v.5q0 .2.3.3-.2-.1-.1-.2.2.2.2-.6.1-.2.1 0-.1.2.4.2v.3l.2-.2q.1-.4-.2-.6l.1-.1.3.2q0-.2-.2-.3l-.4-.1V9.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M45.1 10.6s-.5-.8-.4-.9c.2 0 .4.4.6.3l-.4-.4c-.2-.4-.2-1-.9-1.5.4.6 1.4 1 1.4.8s-.8-.9-.8-1c.2.3 1 1 1.7 1 0-.2-.5-.4-.6-.7L44 6.7l-.7-.8-.1-.1q-.3-.8.3-.8h.3l-.4-.3c.2.2.6 0 .5.4.2 0 .6-.5-.5-.6-.3-.5-1.8-.7-2.2 1l.2.2-2.2-.5C38.1 5 37 4 36.7 4.2l.7.9q-1-.7-2.1-1l-1-.6c-.2.4.7 1.2 1 1.4l1.4.7-2.5-1.2-.7-.6s0 1 1 1.4c.2.1 2.1.8 2 .9l-2.2-1c-.4-.1-1-.7-1-.6-.1 0 .2.6.6.8l1.9.8-2-.8q-.5-.4-.6-.3s.1 1 2.3 1.4l.8-.1-1.2.2s0 .4 1.2.3l.9-.2-1.6.5.9.3 1.5-.3-1 .4h-.4c0 .1.5.6 2.1 0-.1.3-1 .4-1 .5l.5.2h.5l1-.5-1 .7c.3.2 1 0 1.1 0l1.5-1-1.8 1.2c.1.2.8 0 .8 0L41 8s-.9.5-.8.6c0 .4 1.5-.2 1.6-.3 0 0-.8.3-.8.5.3.5 1.1.3 1.2.2v.3l.2-.3-.1.5-.2.7c0 .1.5-.2.5-1l-.1 1.2q.2 0 .4-.7.1.4.4.6V8.7q.7 1 .5 1.8.4-.1.3-.7a1 1 0 0 0 1 .8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    d: "m37.9 5.3-.7.2c0 .4.8 0 .8 0s-.3.5-.6.6h1l.3-.3s-.7.8-.8.7c0 .1.7.1.8 0l.6-.4-1 .7q.6.1 1.5-.4c-.7.5-.7.6-1.1.7.3.1.5.3 1.6-.2q1-.6 1-.8-.7.9-1.7 1.4s.7.4 1.7-.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m37.9 5.3-.7.2c0 .4.8 0 .8 0s-.3.5-.6.6h1l.3-.3s-.7.8-.8.7c0 .1.7.1.8 0l.6-.4-1 .7q.6.1 1.5-.4c-.7.5-.7.6-1.1.7.3.1.5.3 1.6-.2q1-.6 1-.8-.7.9-1.7 1.4s.7.4 1.7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    d: "m43.2 7.5.3.5.3.5m-.8-3 .4.4c.3.2.7.8.7.9l.2 1m-3-1.9c0 .1-.3.6.2 1.3l-.5.7q0 .2.8-.3c.9 1 .6 1.5.6 1.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m43.2 7.5.3.5.3.5m-.8-3 .4.4c.3.2.7.8.7.9l.2 1m-3-1.9c0 .1-.3.6.2 1.3l-.5.7q0 .2.8-.3c.9 1 .6 1.5.6 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    d: "M42.3 8.4v-.5l.4.2s.7.1.7.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M42.3 8.4v-.5l.4.2s.7.1.7.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43 4.5s0-.3-.6 0q.4.2.7 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    d: "M47.6 5.7s1.4.4 1.9.2c-.6.8-1.8.3-1.8.3q.7 0 .8.3l-1.4-.1 1 .4c0 .2-1.7 0-1.8-.3l1 .6c-.3.2-1 .3-2-.5C46.7 8 48 7.8 48.2 8.1c-.5.7-2.4-.5-3.3-1s2 1.4 2.2 1.3c-.1.2-1 0-1.1 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M47.6 5.7s1.4.4 1.9.2c-.6.8-1.8.3-1.8.3q.7 0 .8.3l-1.4-.1 1 .4c0 .2-1.7 0-1.8-.3l1 .6c-.3.2-1 .3-2-.5C46.7 8 48 7.8 48.2 8.1c-.5.7-2.4-.5-3.3-1s2 1.4 2.2 1.3c-.1.2-1 0-1.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    d: "M48 7q-.5.1-.8 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M48 7q-.5.1-.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d00",
    fillRule: "evenodd",
    d: "M37.4 5s1.1.6 1.6.6l-.3.2q0 .2.9 0l-.3.3q0 .2.9 0l-.3.2h.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M37.4 5s1.1.6 1.6.6l-.3.2q0 .2.9 0l-.3.3q0 .2.9 0l-.3.2h.4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZm);
export default __webpack_public_path__ + "static/media/zm.e7e3a434827b4e059b2884af99ec4636.svg";
export { ForwardRef as ReactComponent };